(function () {
  var use_webp = window.canUseWebP || null
  var use_avif = window.canUseAVIF || null

  // Fixed width set. Rounding up to one of these keeps the render cache shared
  // across visitors instead of one file per distinct viewport width.
  var LAZY_WIDTHS = [320, 480, 720, 1080, 1620, 2430, 3840]

  function testWebP(callback) {
    var webP = new Image()
    webP.onload = webP.onerror = function () {
      callback(webP.height == 2)
    }
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA'
  }
  function testAVIF(callback) {
    var avif = new Image()
    avif.onload = avif.onerror = function () {
      callback(avif.height == 1)
    }
    avif.src = 'data:image/avif;base64,AAAAHGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZgAAAPBtZXRhAAAAAAAAAChoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAbGliYXZpZgAAAAAOcGl0bQAAAAAAAQAAAB5pbG9jAAAAAEQAAAEAAQAAAAEAAAEUAAAAFQAAAChpaW5mAAAAAAABAAAAGmluZmUCAAAAAAEAAGF2MDFDb2xvcgAAAABoaXBycAAAAElpcGNvAAAAFGlzcGUAAAAAAAAAAQAAAAEAAAAOcGl4aQAAAAABCAAAAAxhdjFDgQAcAAAAABNjb2xybmNseAABAAEAAQAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB1tZGF0EgAKBxgADlgICAkyCB/xgAAghQm0'
  }
  function atStartup() {
    testWebP(function (canSupport) {
      use_webp = canSupport
      window.canUseWebP = use_webp
    })
    window.canUseAVIF = false
    if (false) {
      testAVIF(function (canSupport) {
        use_avif = canSupport
        window.canUseAVIF = use_avif
      })
    }
  }
  registerListener('load', atStartup)

  setInterval(lazyLoad, 500)
  var lazy = []

  // Round a requested device-pixel width up to the next value in LAZY_WIDTHS,
  // clamped to the largest one.
  function snapWidth(requested) {
    for (var i = 0; i < LAZY_WIDTHS.length; i++) {
      if (requested <= LAZY_WIDTHS[i]) {
        return LAZY_WIDTHS[i]
      }
    }
    return LAZY_WIDTHS[LAZY_WIDTHS.length - 1]
  }

  function lazyLoad() {
    if (use_webp === null) {
      atStartup()
      return
    }
    lazy = document.getElementsByClassName('coglazy')
    if (use_avif) {
      for (var i = 0; i < lazy.length; i++) {
        if (lazy[i].getAttribute('data-avif')) {
          lazy[i].setAttribute('data-src', lazy[i].getAttribute('data-avif'))
          lazy[i].removeAttribute('data-avif')
        }
      }
    }
    else if (use_webp) {
      for (var i = 0; i < lazy.length; i++) {
        if (lazy[i].getAttribute('data-webp')) {
          lazy[i].setAttribute('data-src', lazy[i].getAttribute('data-webp'))
          lazy[i].removeAttribute('data-webp')
        }
      }
    }
    for (var i = 0; i < lazy.length; i++) {
      if (!isInViewport(lazy[i])) {
        continue
      }
      // data-src is both the source and the "still to load" flag: it is removed
      // once the sized file has been assigned to src.
      var srcurl = lazy[i].getAttribute('data-src')
      if (!srcurl) {
        continue
      }
      // Not laid out yet (e.g. closed tab/carousel). Leave it to retry once it
      // has a width and is revealed.
      if (lazy[i].clientWidth <= 0) {
        continue
      }
      var filename = srcurl.split('/').pop()
      var dpr = Math.min(window.devicePixelRatio || 1, 2)
      var width = snapWidth(Math.ceil(lazy[i].clientWidth * dpr))
      var height = Math.round(width * lazy[i].clientHeight / lazy[i].clientWidth)

      lazy[i].src = srcurl.replace(filename, '') + width + 'x' + height + ':' + filename
      lazy[i].removeAttribute('data-src')
    }
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect()
    var screenheight = window.innerHeight || document.documentElement.clientHeight
    var screenwidth = window.innerWidth || document.documentElement.clientWidth
    // Increase height to pre-load on scroll
    screenheight += 200
    return (
      rect.bottom >= 0
      && rect.right >= 0
      && rect.top <= screenheight
      && rect.left <= screenwidth
    )
  }

  function registerListener(event, func) {
    if (window.addEventListener) {
      window.addEventListener(event, func)
    }
    else {
      window.attachEvent('on' + event, func)
    }
  }
})()
